import { ConstraintFacilityTruckDetailBase } from './base/constraint-facility-truck-detail-base';

export class ConstraintFacilityTruckDetail extends ConstraintFacilityTruckDetailBase { }